import * as React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { RunDetail } from './components/run-detail';

export default function OptimisationRunDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const runId = id ? parseInt(id, 10) : undefined;

  if (!runId || isNaN(runId)) {
    return (
      <div className="flex items-center justify-center h-48 text-fg-muted text-sm">
        Invalid run ID.
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(-1)}
          className="-ml-2"
        >
          <ArrowLeft className="h-4 w-4 mr-1" />
          Back
        </Button>
        <h1 className="text-2xl font-bold tracking-tight">Run #{runId}</h1>
      </div>

      <RunDetail runId={runId} />
    </div>
  );
}
